export default "__VITE_ASSET__C7V0Kz1p__"